<template>
  <div class="employee-revise-account">
    <second-menu-link-content>
      <template v-slot:header>
        <span class="title" @click="goEmployeeManage">员工账号/</span>修改账号
      </template>
      <template v-slot:content>
        <div class="employee-revise-account-main">
          <div class="form-container">
            <div class="tit" ref="steps">基础信息</div>
            <div class="form">
              <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-position="right"
                label-width="90px"
              >
                <div class="flex">
                  <el-form-item label="登录账号：" prop="username" class="username">
                    <el-input
                      disabled
                      v-model="ruleForm.username"
                      class="disabled"
                      placeholder="请输入账号"
                    ></el-input>
                    <el-button type="text" class="btn-text" @click="openDialogVisible">修改密码</el-button>
                  </el-form-item>
                  <el-form-item label="姓名：" prop="name">
                    <el-input v-model="ruleForm.name" class="gray" placeholder="请输入姓名"></el-input>
                  </el-form-item>
                  <el-form-item label="邮箱：" prop="email">
                    <el-input v-model="ruleForm.email" class="gray" placeholder="请输入邮箱"></el-input>
                  </el-form-item>
                  <el-form-item label="账号状态：" prop="state">
                    <el-radio-group v-model="ruleForm.state">
                      <el-radio :label="1">启用</el-radio>
                      <el-radio :label="0">禁用</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </div>
                <div class="flex">
                  <el-form-item label="手机：" prop="phone">
                    <el-input
                      v-model="ruleForm.phone"
                      disabled
                      class="disabled"
                      placeholder="请输入手机号"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="部门：" prop="department">
                    <el-select v-model="ruleForm.department" placeholder="请选择部门" class="gray">
                      <el-option
                        v-for="item in department"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="职位：" prop="position">
                    <el-input v-model="ruleForm.position" class="gray" placeholder="请输入职位"></el-input>
                  </el-form-item>
                  <el-form-item label="备注：" prop="remarks">
                    <el-input
                      type="textarea"
                      class="gray"
                      :rows="2"
                      placeholder="请输入内容"
                      v-model="ruleForm.remarks"
                      maxlength="150"
                      show-word-limit
                    ></el-input>
                  </el-form-item>
                </div>
              </el-form>
            </div>
          </div>
          <div class="form-container" v-if="erpForm.erpStatus">
            <div class="tit" ref="steps">ERP对接</div>
            <div class="form">
              <el-form :model="erpForm" label-position="right" label-width="90px">
                <div class="flex">
                  <el-form-item label="员工ID：" prop="position">
                    <el-input v-model="erpForm.erpId" class="gray" placeholder="请输入员工ID"></el-input>
                  </el-form-item>
                  <el-form-item label="Token：" prop="remarks">
                    <el-input
                      type="textarea"
                      class="gray"
                      :rows="2"
                      placeholder="请输入内容"
                      v-model="erpForm.erpToken"
                      maxlength="150"
                      show-word-limit
                    ></el-input>
                  </el-form-item>
                </div>
              </el-form>
            </div>
          </div>
          <el-dialog title="修改密码" :visible.sync="dialogVisible" width="400px" top="25vh">
            <!-- 黑色的线条 -->
            <div class="border"></div>
            <el-form :model="ruleForm" label-width="100px">
              <el-form-item label="新密码：" prop="password">
                <el-input
                  v-model="ruleForm.password"
                  class="gray"
                  type="password"
                  placeholder="请输入新密码"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button class="btn-white" type="primary" @click="reset">取消</el-button>
                <el-button class="btn-blue" @click="changePassword">保存</el-button>
              </el-form-item>
            </el-form>
          </el-dialog>
          <div class="operations" ref="operations">
            <el-button class="btn-white" @click="cancel">取消</el-button>
            <el-button class="btn-blue" @click="save('ruleForm')">保存</el-button>
          </div>
        </div>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script >
import SecondMenuLinkContent from "components/layout/SecondMenuLinkContent";
import DBSiteSet from "models/db/site-set.js";
const dbSiteSet = new DBSiteSet();
export default {
  data() {
    return {
      ruleForm: {
        id: "",
        username: "",
        password: "",
        name: "",
        state: "",
        phone: "",
        department: "",
        position: "",
        email: "",
        remarks: ""
      },
      rules: {
        username: [
          { required: true, message: "请输入账号名称", trigger: "blur" }
        ],
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        position: [{ required: true, message: "请输入职位", trigger: "blur" }],
        department: [
          { required: true, message: "请选择部门", trigger: "change" }
        ],
        state: [
          { required: true, message: "请选择是否启用", trigger: "change" }
        ]
      },
      erpForm: {
        erpId: "",
        erpToken: "",
        erpStatus: ""
      },
      dialogVisible: false,
      department: [] // 部门数据
    };
  },
  components: {
    SecondMenuLinkContent
  },
  mounted() {
    const paddingWidth = 48;
    this.$refs.operations.style.width =
      this.$refs.steps.clientWidth + paddingWidth + "px";
    window.onresize = () => {
      this.$refs.operations.style.width =
        this.$refs.steps.clientWidth + paddingWidth + "px";
    };
  },
  beforeMount() {
    this.ruleForm.id = this.$route.query.id;
    this.getData();
    this.getDepartment();
  },
  methods: {
    goEmployeeManage() {
      this.$router.push("employee-manage");
    },
    // 根据id获取当前页数据
    getData() {
      let id = this.ruleForm.id;
      dbSiteSet.getDBEmployeeById(id).then(res => {
        if (res.success) {
          this.ruleForm.username = res.result.username;
          this.ruleForm.name = res.result.contact;
          this.ruleForm.email = res.result.email;
          this.ruleForm.position = res.result.position;
          this.ruleForm.phone = res.result.telephone;
          this.ruleForm.department = res.result.departmentId;
          this.ruleForm.state = res.result.status;
          this.ruleForm.remarks = res.result.note;
          // this.getDepartment();
          this.erpForm.erpStatus = res.result.erpStatus === 1 ? true : false;
          this.erpForm.erpId = res.result.erpId;
          this.erpForm.erpToken = res.result.erpToken;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 获取部门数据
    getDepartment() {
      dbSiteSet.getDBAllDepartment().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map((value, index, array) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            obj.authority = value.authorityIds;
            arr.push(obj);
          });
          this.department = arr;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 修改密码
    openDialogVisible() {
      this.dialogVisible = true;
    },
    // 取消修改密码
    reset() {
      this.dialogVisible = false;
      this.ruleForm.password = "";
    },
    // 确认修改密码
    changePassword() {
      let id = this.ruleForm.id;
      let password = this.ruleForm.password;
      if (password === "") {
        this.$message.error("密码不能为空");
        return false;
      }
      dbSiteSet.postDBUpdatePossword(id, password).then(res => {
        if (res.success) {
          this.$message.success("修改成功");
          this.dialogVisible = false;
          this.ruleForm.password = "";
        } else {
          this.ruleForm.password = "";
          this.$message.error(res.message);
        }
      });
    },
    // 保存修改
    save(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let userId = Number(this.ruleForm.id);
          let contact = this.ruleForm.name;
          let email = this.ruleForm.email;
          let departmentId = this.ruleForm.department;
          let position = this.ruleForm.position;
          let note = this.ruleForm.remarks;
          let status = this.ruleForm.state;
          let telephone = this.ruleForm.phone;
          let erpId = this.erpForm.erpId;
          let erpToken = this.erpForm.erpToken;
          let data = {
            userId,
            contact,
            email,
            departmentId,
            position,
            note,
            status,
            telephone,
            erpId,
            erpToken
          };
          dbSiteSet.postDBUpdateEmployee(data).then(res => {
            if (res.success) {
              this.$message.success("修改成功");
              this.$router.push({
                name: "employee-manage",
                params: {
                  change: true
                }
              });
            } else {
              this.$message.error("修改失败，请重新修改！");
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 取消
    cancel() {
      this.$router.push("employee-manage");
    }
  }
};
</script>

<style lang="scss" scoped>
.employee-revise-account {
  width: 100%;
  height: 100%;
  .title {
    color: rgba(61, 116, 242, 0.75);
    cursor: pointer;
    &:hover {
      color: rgba(61, 116, 242, 1);
    }
  }
  .employee-revise-account-main {
    .tit {
      height: 32px;
      background: rgba(245, 247, 250, 1);
      border-radius: 8px 8px 0px 0px;
      padding-left: 6px;
      line-height: 32px;
      color: rgba(48, 49, 50, 1);
      font-size: 16px;
    }
    .form-container {
      .form {
        padding-top: 16px;
      }
    }
    .operations {
      z-index: 10;
      height: 60px;
      position: fixed;
      left: 256px;
      bottom: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 6px 0px rgba(219, 223, 230, 1);
      .el-button {
        width: 96px;
        letter-spacing: 4px;
      }
      .el-button + .el-button {
        margin-left: 24px;
      }
    }
  }
}
</style>
<style lang="scss">
.employee-revise-account {
  .employee-revise-account-main {
    .form-container {
      .form {
        .el-form {
          display: flex;
          .el-form-item__label {
            padding: 0;
          }
          .username {
            position: relative;
            .btn-text {
              position: absolute;
              top: 0;
              right: -55px;
            }
          }
          .el-radio {
            margin-right: 16px;
          }
          .is-error {
            .el-input__inner:focus {
              border-color: #3d74f2;
            }
          }
          .flex {
            flex: 1;
          }
          .el-form-item__content {
            width: 320px;
            .el-select {
              width: 100%;
            }
            .el-input__count {
              background: rgba(234, 238, 245, 0.2);
            }
            .el-textarea__inner {
              background: rgba(234, 238, 245, 0.2);
              border-radius: 4px;
              border: 1px solid rgba(234, 238, 245, 1);
            }
            .el-textarea__inner:hover {
              border-color: rgba(192, 196, 204, 1);
            }
            .el-textarea__inner:focus {
              border-color: rgba(61, 116, 242, 1);
            }
          }
        }
      }
    }
    .el-dialog {
      .el-form {
        .el-form-item:last-child {
          margin-bottom: 0px;
          .el-button {
            width: 96px;
          }
        }
      }
    }
  }
}
</style>
